import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateReportJobDto } from '../../dtos/create-report-job.dto';
import { UpdateReportJobDto } from '../../dtos/update-report-job.dto';
import { createReportJobSchema } from '../schemas/create-report-job.schema';
import { updateReportJobSchema } from '../schemas/update-report-job.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateReportJobDto | UpdateReportJobDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateReportJobSchema if 'id' is present
		validationResult = updateReportJobSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createReportJobSchema if 'id' is not present
		validationResult = createReportJobSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
